module.exports = __webpack_public_path__ + "img/6685eda.png";